import AllSettings from "./AllSettings"
export default AllSettings
